const action = {
    sign_in: 'Đăng nhập',
    continue: 'Tiếp tục',
    continue_as: 'Tiếp tục với {{name}}',
    create_account: 'Tạo tài khoản',
    create_account_without_linking: 'Tạo tài khoản mới thay thế',
    create: 'Tạo',
    enter_passcode: 'Nhập mã xác minh',
    confirm: 'Xác nhận',
    cancel: 'Hủy',
    save_password: 'Lưu mật khẩu',
    bind: 'Liên kết với {{address}}',
    bind_and_continue: 'Liên kết và tiếp tục',
    back: 'Quay lại',
    nav_back: 'Quay lại',
    nav_skip: 'Bỏ qua',
    agree: 'Đồng ý',
    got_it: 'Đã hiểu',
    sign_in_with: 'Tiếp tục với {{name}}',
    forgot_password: 'Quên mật khẩu?',
    switch_to: 'Chuyển sang {{method}}',
    sign_in_via_passcode: 'Đăng nhập bằng mã xác minh',
    sign_in_via_password: 'Đăng nhập bằng mật khẩu',
    sign_in_via_passkey: 'Đăng nhập bằng passkey',
    change: 'Đổi {{method}}',
    link_another_email: 'Liên kết email khác',
    link_another_phone: 'Liên kết số điện thoại khác',
    link_another_email_or_phone: 'Liên kết email hoặc số điện thoại khác',
    show_password: 'Hiện mật khẩu',
    copy: 'Sao chép',
    verify_via_passkey: 'Xác minh bằng passkey',
    download: 'Tải xuống',
    remove: 'Xóa',
    edit: 'Sửa',
    save: 'Lưu',
    single_sign_on: 'Đăng nhập một lần (SSO)',
    authorize: 'Cấp quyền',
    use_another_account: 'Dùng tài khoản khác',
    back_to_current_account: 'Quay lại tài khoản hiện tại',
    done: 'Xong',
};
export default Object.freeze(action);
